import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Main',
  attributeName: 'mainGraphicManagers',
  fields: [
    // {
    //   attributeName: 'id',
    //   label: 'Id',
    //   required: true,
    //   disabled:true,
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   placeholder: 'ID',
    //   helpText: 'ID.',
    //   className:'col-sm-6',
    //   hidden:true
    // },
    {
      attributeName: 'name',
      label: 'Name',
      default:'',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Name',
      helpText: 'Name.',
      className:'col-sm-12'
    },
    {
      attributeName: 'type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Type',
      default:'',
      required: true,
      disabled:true,
      placeholder: 'Type',
      helpText: 'Type of manager.',
      className:'col-sm-12'
    },
    {
      attributeName: 'objective',
      type: FormInputTypes.ARRAY,
      label: 'Objective',
      default:'',
      required: true,
      disabled:true,
      fields:["name","duration"],
      placeholder: 'Objective',
      helpText: 'Objective.',
      className:'col-sm-12',
      visibleWhen:{"field":"type","value":"VOD"}
    },
    {
      attributeName: 'objective',
      type: FormInputTypes.ARRAY,
      label: 'Objective',
      default:'',
      required: true,
      disabled:true,
      fields:["name"],
      placeholder: 'Objective',
      helpText: 'Objective.',
      className:'col-sm-12',
      visibleWhen:{"field":"type","value":"LIVE"}
    },
  ],
};
